<template>
        <v-card-text v-if="trainerObj" class="pa-1 ma-0">
            <v-card-title class="pa-0 ma-0" :class="textColorClass">
                <v-col class="text-center" :class="{'secondTranparent': !stadionFightReport}">{{introduction}} {{trainerObj.fullName}}</v-col>
            </v-card-title>
            <v-card-text class="pa-2 ma-0 pt-0 pb-0">
                <v-row class="pa-0 pt-4 pr-1">
                    <v-col v-if="!reverse && !obstacleView" cols="4" class="text-center text-center font-weight-bold headline secondTranparent" :class="textColorClass">
                        <v-row class="trainer-block-stat-row">
                            <v-col  class="pa-0" cols="12">  {{trainerObj.trainerSkills.trainerIni}}  <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-star-circle</v-icon></v-col>
                        </v-row>
                        <v-row class="trainer-block-stat-row">
                            <v-col  class="pa-0"  cols="12"> {{trainerObj.trainerSkills.aim}}    <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-pokeball</v-icon></v-col>
                        </v-row>
                        <v-row class="trainer-block-stat-row">
                            <v-col  class="pa-0"  cols="12"> {{trainerObj.trainerSkills.pokeIni}}    <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-brain</v-icon></v-col>
                        </v-row>
                        <v-row class="trainer-block-stat-row">
                            <v-col  class="pa-0"  cols="12"> {{trainerObj.trainerSkills.luck}}    <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-horseshoe</v-icon></v-col>
                        </v-row>
                        <v-row class="trainer-block-stat-row">
                            <v-col  class="pa-0"  cols="12"> {{trainerObj.trainerSkills.enduancer}}    <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-dumbbell</v-icon></v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="8">
                        <v-img
                            v-if="trainerObj.img"
                            class="self-center trainer-block-portrait"
                            :src="require(`@/assets/pic/trainer/${trainerObj.img}`)"
                            contain
                        >
                            <div style="position: absolute; top: 0; left: 0">
                                <v-img
                                    class="ma-1"
                                    v-for="badge in trainerObj.badges.slice(0,4)"
                                    :key="badge.id"
                                    :src="require(`@/assets/pic/badge/${badge.id}.png`)"
                                    style="z-index: -10; width: 40px; height: 40px"
                                    contain
                                />
                            </div>
                            <div style="position: absolute; top: 0; right: 0">
                                <v-img
                                    class="ma-1"
                                    v-for="badge in trainerObj.badges.slice(4)"
                                    :key="badge.id"
                                    :src="require(`@/assets/pic/badge/${badge.id}.png`)"
                                    style="z-index: -10; width: 40px; height: 40px"
                                    contain
                                />
                            </div>
                        </v-img>
                    </v-col>
                    <v-col v-if="reverse && !obstacleView" cols="4" class=" text-center font-weight-bold headline secondTranparent" :class="textColorClass">
                        <v-row class="trainer-block-stat-row">
                            <v-col  class="pa-0" cols="12"> <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-star-circle</v-icon> {{trainerObj.trainerSkills.trainerIni}} </v-col>
                        </v-row>
                        <v-row class="trainer-block-stat-row">
                            <v-col  class="pa-0"  cols="12">  <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-pokeball</v-icon> {{trainerObj.trainerSkills.aim}} </v-col>
                        </v-row>
                        <v-row class="trainer-block-stat-row">
                            <v-col  class="pa-0"  cols="12">  <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-brain</v-icon> {{trainerObj.trainerSkills.pokeIni}} </v-col>
                        </v-row>
                        <v-row class="trainer-block-stat-row">
                            <v-col  class="pa-0"  cols="12">  <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-horseshoe</v-icon> {{trainerObj.trainerSkills.luck}} </v-col>
                        </v-row>
                        <v-row class="trainer-block-stat-row">
                            <v-col  class="pa-0"  cols="12">  <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-dumbbell</v-icon> {{trainerObj.trainerSkills.enduancer}} </v-col>
                        </v-row>
                    </v-col>
                    <v-col v-if="reverse && obstacleView" cols="4" class=" text-center text-center font-weight-bold headline secondTranparent" :class="textColorClass">
                        <v-row>
                            <p class="title"> {{ $t('trainer.trainerBlock.dungeoneeringBonus') }}</p>
                        </v-row>
                        <v-row>
                            <v-col  class="pa-0" cols="12">
                                <v-icon :class="['trainer-block-stat-icon', textColorClass]">mdi-pickaxe</v-icon>
                                {{trainerObj.trainerSkills.dung}}
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

            </v-card-text>
        </v-card-text>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    // import {API_ENTRYPOINT} from "@/config/entrypoint";

    export default {
        components: {},
        props: {
          introduction : {String, default: null},
          trainerId: {Number, default: null},
          reverse: {Boolean, default: false},
          obstacleView: {Boolean, default: false},
          stadionFightReport: {Boolean, default: false},
        },
        data() {
            return {
                trainerObj: null,
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/item',
            }),
            // v dark theme by natvrdo cerny text splyval s tmavou kartou (TrainerTile.vue .transparent03--dark)
            textColorClass() {
                return this.$vuetify.theme.dark ? 'white--text' : 'black--text';
            },
        },
        created() {
            this.getTrainer(this.trainerId).then(
                (data) => {
                    this.trainerObj = data;
                }
            );
        },
        methods: {
            ...mapActions({
                getTrainer: 'trainer/loadItem',
                updatePokemon: 'pokemon/updateItem',
                fetchObject: 'trainer/fetchObject'
            }),
        },
    }
</script>

<style scoped>
/* vh-relativni strop (min()) misto natvrdo max-height - stejny vzor jako MewtwoChallengeDialog.vue banner, EditProfile.vue carousel */
.trainer-block-portrait {
    height: min(220px, 26vh);
}
.trainer-block-stat-icon {
    font-size: min(26px, 3.2vh) !important;
}
</style>

